import { OrderListItemBigContent } from 'app/src/features/UserAccount/components/OrderListItemBigContent'
import { OrderListItemSmallContent } from 'app/src/features/UserAccount/components/OrderListItemSmallContent'
import type { GenericOrderItem } from 'app/src/model'

import { Card } from 'primereact/card'
import type { ReactElement } from 'react'

export function OrderListItem(props: { item: GenericOrderItem }): ReactElement {
  return (
    <Card
      pt={{
        root: { className: 'w-full border border-solid border-[var(--primary-color)]' },
        body: { className: 'p-2 xl:p-1 min-w-0 overflow-hidden' },
        content: { className: 'min-w-0 overflow-hidden' },
      }}
    >
      <div className='hidden md:block'>
        <OrderListItemBigContent item={props.item} />
      </div>
      <div className='block md:hidden'>
        <OrderListItemSmallContent item={props.item} />
      </div>
    </Card>
  )
}
